

































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import FileDrop from "@/components/common/FileDrop.vue";
import FileItem from "@/components/common/FileItem.vue";
import DropZone from "@/components/common/DropZone.vue";
import ChoiceMappingTables from "@/views/ChoiceImport/ChoiceMappingTables.vue"
import { API, Storage } from "aws-amplify";

import { Urls } from "@/Urls";
import { getModule } from "vuex-module-decorators";
import Decisions from "@/store/modules/Decisions";
import Modelling from "@/store/modules/Modelling";
const decisionsModule = getModule(Decisions)
const modellingModule = getModule(Modelling)
const papa = require('papaparse');

interface csvValue {
    column: number;
    name: string;    
};

interface csvColumn {
    column: string;
    values: string[];    
};

@Component({
  components: { DropZone, FileItem, FileDrop, ChoiceMappingTables },
})



export default class ChoiceTableImporter extends Vue {
    @Prop({default: '', type: String})
    header!: string;

    @Prop({default: '', type: String})
    placeholder!: string;

    @Prop({default: '', type: String})
    hint!: string;

    @Prop({default: '', type: String})
    label!: string;

    @Prop({default: '', type: String})
    icon!: string;

    @Prop({default: '', type: String})
    btnText!: string;

    @Prop({default: false, type: Boolean})
    xSmall: boolean;

    @Prop({default: false, type: Boolean})
    small: boolean;

    @Prop({default: false, type: Boolean})
    large: boolean;

    @Prop({default: false, type: Boolean})
    xLarge: boolean;

    @Prop({default: false, type: Boolean})
    disabled!: boolean;

    @Prop({default: null, type: Object})
    columnHeaders!: Object;

    @Prop({default: null, type: Object})
    tableColumns!: Object;

    private step = 1;
    private file: any = null;
    private name = '';
    private description = '';
    private uploadError = null;
    private uploading = false;
    private uploaded = false;
    private uploadProgressPercent: number | null = null
    private objectKey: string | null = null;
    private dialog = false;
    private API_NAME = "Viewpoint360API";
    private output = []
    private headers: String[] = [];
    private csvHeaders: csvValue[] = [];
    private map:{[key: string]: number} = {}
    private loading = false;
    private csvResults:{[key: string]: string[]} = {};
    private mappedResults: csvColumn[] = [];
    private increment = 0;

    get selectedDecision() {
        console.log(this.tableColumns)
        return decisionsModule.selectedDecision;
    }

    private async fileSelected(files: any) {
        this.file = files[0];     
        try {
            this.uploadError = null;
            this.objectKey = await this.uploadFile(this.file);
            this.step++;
            await this.getHeadersFromFile(this.file)
        } catch (e) {
            console.log(e)
            this.uploadError = e
        }
        this.increment++;
    }

    private async uploadFile(file: any) {
        const key: string = `ingest/csv/${file.name}`;
        this.uploading = true;
        let uploadResponse: any = await Storage.put(key, file, {
        progressCallback: (progress: any) => {
            this.uploadProgressPercent = progress.loaded / progress.total
        }
        })
        this.uploading = false;
        this.uploaded = true;
        return uploadResponse.key;
  }

    private async getHeadersFromFile(file: File) {
        papa.parse(file, {
        complete: (results: any) => {
            this.headers = results.data[0]
            let i = 0;
            this.csvResults = results.data.slice(1);

            results.data[0].forEach((value:string, index: number) => {
                let newHeader = {} as csvValue;
                newHeader.column = index;
                newHeader.name = (value) ? (value): `Column ${index}`;
                this.csvHeaders.push(newHeader);
            });
        }
        });
    }

    private async submit() {
        this.loading = true;
        this.step = 3;
        let mapped: {[key: string]: string[]} = {};
        
        try {
            for(const[key,value] of Object.entries(this.map)) {
                let newColumn = {} as csvColumn;
                newColumn.column = key;
                newColumn.values = [];
                for(const csvRow of Object.values(this.csvResults)) {
                    csvRow[value] ?  newColumn.values.push(csvRow[value]): null
                }
                mapped[newColumn.column] = newColumn.values;
            }
        
            this.loading = false
            this.$emit('ingest', mapped);
        } catch (err) {
            this.uploadError = err;
        }
    }

    private back() {
        this.step--;

        if(this.step === 1) {
            this.csvHeaders = [];
            this.csvResults = {};
            this.file = null;
        }

        if(this.step <= 0) {
            this.step = 1;
            this.dialog = false;
        }
    }

    private close() {
        this.dialog = false;
        this.step = 1;
        this.file = null;
        this.csvHeaders = [];
        this.csvResults = {};
        this.map = {};
    }

    private mapHeaders(val: any) {
        this.map = val;
    }

    private addIncrement() {
        this.increment = ++this.increment
        this.file=null;
    }

    @Watch('dialog')
    private onChangeShowing(){
        this.increment = ++this.increment;
        console.log(this.increment);
        this.file = null;
        this.step = 1;
    }
}
